export default __webpack_public_path__ + "static/media/arc-logo_white.266f4b2b.png";